var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClearSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-Contacts---search-results",
    transform: "translate(-1144.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-clear-search",
    transform: "translate(1154.000000, 70.000000) rotate(45.000000) translate(-1154.000000, -70.000000) translate(1144.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#1495CD",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    x: 9.5,
    y: 6,
    width: 1,
    height: 8,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    x: 6,
    y: 9.5,
    width: 8,
    height: 1,
    rx: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearSearch);
export default __webpack_public_path__ + "static/media/icon-clear-search.efa89bbd60d3b989e661d9c60f415297.svg";
export { ForwardRef as ReactComponent };